import type { AccountCoupon } from "@nlc/shared-types";

import { PlusIcon } from "lucide-react";
import { useState } from "react";

import { CreditCardEditIcon } from "@/assets/icons/CreditCardEditIcon";
import { Badge } from "@/components/badge";
import { Button } from "@/components/button";

import { AddCouponModal } from "./AddCouponModal";

interface CouponsCardProps {
  readonly coupons: AccountCoupon[];
  readonly projectId: number;
}

export function CouponsCard({ coupons, projectId }: CouponsCardProps) {
  const [isAddOpen, setIsAddOpen] = useState(false);

  return (
    <div className="grid grid-cols-[1fr_auto] content-between items-center gap-md rounded-xl border border-border-secondary bg-bg-primary px-3xl py-xl lg:items-start">
      <h3 className="text-xl font-semibold text-text-primary">Coupons</h3>

      {coupons.length === 0 && (
        <Button
          className="justify-self-end px-xs lg:order-last lg:col-span-2 lg:justify-self-start"
          color="color"
          onPress={() => setIsAddOpen(true)}
          size="md"
          variant="tertiary"
        >
          <PlusIcon />
          Add coupon
        </Button>
      )}

      <div className="hidden h-10 w-10 items-center justify-center justify-self-end rounded-md bg-bg-brand-secondary lg:flex">
        <CreditCardEditIcon className="text-text-brand-primary" />
      </div>

      {coupons.length > 0 && (
        <ul className="col-span-2 flex flex-wrap gap-md">
          {coupons.map((coupon) => (
            <li key={coupon.id}>
              <Badge isRounded variant="success">
                {coupon.code}
              </Badge>
            </li>
          ))}
        </ul>
      )}

      {isAddOpen && (
        <AddCouponModal
          onClose={() => setIsAddOpen(false)}
          projectId={projectId}
        />
      )}
    </div>
  );
}
